import './App.css';
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Lazy load all page components
const NewToChrist = lazy(() => import('./NewToChrist'));
const Bishop = lazy(() => import('./Bishop'));
const Giving = lazy(() => import('./Giving'));
const Board = lazy(() => import('./Board'));
const Theme = lazy(() => import('./Theme'));
const PstChichi = lazy(() => import('./PstChichi'));
const Vision = lazy(() => import('./Vision'));
const Covkids = lazy(() => import('./CovKids'));
const Covcare = lazy(() => import('./CovCare'));
const Covwomen = lazy(() => import('./CovWomen'));
const Ingnite = lazy(() => import('./Ignite'));
const Kings = lazy(() => import('./Kings'));
const Bible = lazy(() => import('./Bible'));
const KC = lazy(() => import('./KC'));
const Contacts = lazy(() => import('./Contact'));
const HomeMain = lazy(() => import('./HomeMain'));
const UpdatesMain = lazy(() => import('./UpdatesMain'));
const News = lazy(() => import('./News'));
const Membernew = lazy(() => import('./Membernew'));
const NIC = lazy(() => import('./NIC'));

// Loading component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#fff'
  }}>
    <div className="page-loader">
      <div className="loader-spinner"></div>
      <p style={{ marginTop: '1rem', color: '#666' }}>Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <div className='App'>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path='/' element={<HomeMain />} />
            <Route path='/home' element={<HomeMain />} />
            <Route path='/events' element={<UpdatesMain />} />
            <Route path='/updates' element={<News />} />
            <Route path='/member' element={<Membernew />} />
            <Route path='/covenant-kids' element={<Covkids />} />
            <Route path='/covenant-care' element={<Covcare />} />
            <Route path='/covenant-women' element={<Covwomen />} />
            <Route path='/youth' element={<Ingnite />} />
            <Route path='/bible' element={<Bible />} />
            <Route path='/nic' element={<NIC />} />
            <Route path='/kings-fellowship' element={<Kings />} />
            <Route path='/kingdom-cathedral' element={<KC />} />
            <Route path='/board' element={<Board />} />
            <Route path='/vision' element={<Vision />} />
            <Route path='/theme' element={<Theme />} />
            <Route path='/giving' element={<Giving />} />
            <Route path='/contact' element={<Contacts />} />
            <Route path='/newtochrist' element={<NewToChrist />} />
            <Route path='/bishop-tudor' element={<Bishop />} />
            <Route path='/pastor-chichi' element={<PstChichi />} />
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;